import { trackError } from '../../utils/trackError';
import type {
  DatalayerEventPayload,
  DatalayerVisitPayload,
  TrackTMSPageDatalayer,
} from './types';

export const TMS_PAGE_BOUNDARY = 'trackTMSPage';
export const TMS_DATA_MESSAGE =
  'page_name and env_template are required to track TMS page';
export const TMS_DATA_CONFIRMATION_MESSAGE =
  'transaction_id is required to track confirmation in TMS';
export const handleTmsDataError = (
  datalayer: Partial<TrackTMSPageDatalayer>
) => {
  const data = datalayer || {};
  if (!data.page_name || !data.env_template) {
    const errorMessage = `${TMS_DATA_MESSAGE}. Received page_name: "${
      data.page_name
    }" and env_template: "${data.env_template}"${
      data.product ? ` for product: ${data.product}` : ''
    }`;
    void trackError(new Error(errorMessage), TMS_PAGE_BOUNDARY);
    return;
  }
  if (
    data.page_name === 'confirmation' &&
    (!data.transaction_id || !data.product)
  ) {
    const errorMessage = `transaction_id is required to track confirmation in TMS. Received transaction_id: "${data.transaction_id}" and product: "${data.product}"`;
    void trackError(new Error(errorMessage), TMS_PAGE_BOUNDARY);
  }
};

export const TMS_EVENT_BOUNDARY = 'fireEvent';
export const TMS_EVENT_DATA_MESSAGE = 'data is required to track TMS event';
export const TMS_EVENT_CATEGORY_DATA_MESSAGE =
  'event_category is required to track TMS event';
export const tmsEventDataContainsErrors = (data: DatalayerEventPayload) => {
  if (!data) {
    void trackError(new Error(TMS_EVENT_DATA_MESSAGE), TMS_EVENT_BOUNDARY);
    return true;
  }
  if (!data?.event_category) {
    void trackError(
      new Error(TMS_EVENT_CATEGORY_DATA_MESSAGE),
      TMS_EVENT_BOUNDARY
    );
    //Non-blocker, return false
    return false;
  }
  return false;
};

export const TMS_VISIT_BOUNDARY = 'trackVisit';
export const TMS_VISIT_DATA_MESSAGE =
  'event_category is required to track visit event';
export const TMS_VISIT_PAYLOAD_MESSAGE =
  'data is required to track visit event';
export const visitDataContainsErrors = (
  data: DatalayerVisitPayload
): boolean => {
  if (!data) {
    void trackError(new Error(TMS_VISIT_PAYLOAD_MESSAGE), TMS_VISIT_BOUNDARY);
    return true;
  }
  if (!data.event_category) {
    void trackError(new Error(TMS_VISIT_DATA_MESSAGE), TMS_VISIT_BOUNDARY);
    return true;
  }
  return false;
};
